export default "__VITE_PUBLIC_ASSET__e51597cf__"